import { createContext, useContext } from 'react';
import { NavProps } from './types';

export type NavContextProps = NavProps;

export const NavContext = createContext<NavContextProps>({});

export const useNavContext = () => useContext(NavContext);
